import { put } from 'redux-saga/effects';
import { fetchCollectionApi } from 'common/api/index';
import { collectionSetInStoreAction } from 'common/actions/collection';
import { errorHandleAction } from 'components/error-handle/actions';
import { collectionIsLoadingAction } from 'common/actions';

/**
 * @param {collectionRequestAction} action
 */
export function* collectionRequestEffect(action) {
  try {
    yield put(collectionIsLoadingAction());
    const { collectionId, pageNum, perPage, sortingBy, featuredFirst } = action.payload;

    const collection = yield fetchCollectionApi({
      channelId: collectionId,
      pageNum,
      perPage,
      sorting: sortingBy,
      featuredFirst,
    });
    yield put(collectionSetInStoreAction(collection));
  } catch (error) {
    yield put(errorHandleAction(error, error.status));
  }
}

export function* collectionRequestOnMobileEffect({ payload }) {
  try {
    yield put(collectionIsLoadingAction());
    const { collectionId, perPage, sortingBy, previousVideos, featuredFirst } = payload;

    let { pageNum } = payload;
    pageNum = ++pageNum;

    const collection = yield fetchCollectionApi({
      channelId: collectionId,
      pageNum,
      perPage,
      sorting: sortingBy,
      featuredFirst,
    });

    if (pageNum > 1) {
      collection.videos = [].concat(previousVideos, collection.videos);
      collection.pageNum = pageNum;
    }

    yield put(collectionSetInStoreAction(collection));
  } catch (error) {
    yield put(errorHandleAction(error, error.status));
  }
}
